import React from "react";
import Button from "../Button/Button.component";
import Icon from "../Icon/Icon.component";
import { ButtonVariant } from "../Button/Button.styled";
import {
  PlanDescription,
  PlanKicker,
  PlanList,
  PlanName,
  PlanNote,
  PlanWrapper,
  PriceLine,
  PriceNumber,
  PriceUnit,
} from "./PlanCard.styled";

export interface IPlanCta {
  label: string;
  variant: string;
  /** Opens the app instead of the demo dialog. */
  href?: string;
  /** Plan name carried into the demo request. */
  plan?: string;
}

interface IPlanCard {
  featured?: boolean;
  kicker: string;
  name: string;
  price: string;
  unit: string;
  description: string;
  features: string[];
  note?: string;
  cta: IPlanCta;
  onRequestDemo: (plan?: string) => void;
}

const PlanCard = ({
  featured,
  kicker,
  name,
  price,
  unit,
  description,
  features,
  note,
  cta,
  onRequestDemo,
}: IPlanCard) => (
  <PlanWrapper featured={featured}>
    <PlanKicker featured={featured}>{kicker}</PlanKicker>
    <PlanName>{name}</PlanName>
    <PriceLine>
      <PriceNumber>{price}</PriceNumber>
      <PriceUnit>{unit}</PriceUnit>
    </PriceLine>
    <PlanDescription>{description}</PlanDescription>
    <PlanList>
      {features.map((feature) => (
        <li key={feature}>
          <Icon name="check" />
          {feature}
        </li>
      ))}
    </PlanList>
    {note && <PlanNote>{note}</PlanNote>}
    <Button
      variant={cta.variant as ButtonVariant}
      href={cta.href}
      onClick={cta.href ? undefined : () => onRequestDemo(cta.plan)}
    >
      {cta.label}
    </Button>
  </PlanWrapper>
);

export default PlanCard;
